export default {
  common: {
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    close: 'Close',
    logout: 'Logout',
    confirm: 'Confirm',
    continue: 'Continue',
    sendAgain: 'Send again',
    serverError: 'Server error',
    contactViaWhatsapp: 'Contact via WhatsApp'
  },
  errors: {
    unknownEmail: 'Unknown email address',
    minGroupSize: (ctx) => `Minimum group size is ${ctx.named('value')} persons`,
    reservationNotFound: 'Reservation with such number could not be found'
  },
  ui: {
    select: {
      clear: 'Clear'
    },
    validator: {
      required: 'Required field',
      phoneOrEmailRequired: 'Phone number or Email are required',
      phoneOrEmailOrReservationRequired: 'Missing phone number/email or reservation number',
      badPhone: 'Enter a valid phone number',
      badEmail: 'Enter a correct email address',
      badOtp: 'Enter a 6-digit code'
    },
    loading: {
      reservation: 'Reservation...',
      reservationUpdate: 'Reservation updating...',
      reservationCancel: 'Reservation cancellation...',
      update: 'Updating...'
    }
  },
  forms: {
    signin: 'Sign In',
    signup: 'Sign Up',
    profile: 'Profile',
    otpTokenRequest: 'Please enter your code',
    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Tel',
      email: 'Email',
      otpCode: 'Code',
      reservationNumber: 'Reservation Number',
      wheelchair: 'Wheelchair',
      highchair: 'High chair(s)',
      highchairFull: 'High chair(s) (for little kids)',
      highchairsCount: 'Number of high chairs (if needed)',
      disabledGuestsQuestion: 'Disabled guests in the party?'
    },
    checkboxes: {
      subscribe: 'Subscribe to offers and news',
      rememberme: 'Remember me on this device'
    }
  },
  pages: {
    index: {
      heading1: 'Welcome to our restaurant!',
      heading2: 'You can now reserve a table in our restaurant.',
      heading3: 'When will you visit?',
      xmasGreeting: 'Celebrate Christmas at Loetje!',
      whereToSit: 'Where would you like to sit?',
      today: 'Today',
      tomorrowOrLater: 'Tomorrow or later',
      xmas: 'Christmas',
      start: 'Start',
      changeReservation: 'Change or cancel existing reservation',
      form: {
        partySize: 'How many people are in your party?',
        when: 'What time will you arrive?',
        location: 'Where would you like to be seated?'
      }
    },
    filter: {
      partySize: 'How many people are in your party?',
      partySizeHint: (ctx) => `Maximum group size is ${ctx.named('value')} persons.`,
      when: 'What time will you arrive?',
      location: 'Where would you like to sit?',
      locationLabel: 'Location',
      noSlots: (ctx) => {
        let partySize = ctx.named('partySize') || 2
        let text = ''

        switch (true) {
          case partySize < 7:
            text = `At Loetje, there's always a table for you. You can start with a drink at the bar and usually get seated quickly. So come on by and enjoy!`
            break
          case partySize >= 7:
            text = `At Loetje, there's always a table for you. You can start with a drink at the bar and usually get seated quickly. So come on by and enjoy!`
            break
        }

        return text
      },
      noSlotsDescription: 'Did you know you can also come without a reservation and try our terrace?',
      bqtProposalText: 'Larger company?',
      bqtProposalHint: (ctx) => `
        Below you will find the locations in the area where you can make a reservation directly for a larger company
        or contact us, we are happy to look into it with you.
        (<a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a>)
        (van 11:00-20:00)
      `,
      goBqtFooterHint: (ctx) => `
        Looking for a suitable location and package together?
        We are happy to help you
        (<a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a>)
        (from 11:00 to 20:00)
      `,
      selectLocation: 'Select a location to check availability',
      noAlternatives: 'No alternative Loetje locations available.',
      changeDate: 'Choose a different date to join us.',
      allRestaurantsClosed: `Due to our annual staff party,
        all Loetje locations will be closed on Monday, January 5.<br>
        We would love to welcome you on another day!
      `,
      dineTimeChristmasNotice: `Celebrate Christmas at Loetje 🎄 We are open on December 25 & 26.
        Reservations for these dates will be available starting in October.
        We look forward to welcoming you this Christmas!`,
      chooseRestaurant: 'Select',
      xmasLargeGroupMessage: `
        <p>For parties of 12 guests or more we offer special Christmas arrangements. We are happy to help you choose the best option.</p>
        <p>Send us a message on WhatsApp — we're happy to advise you on the possibilities.</p>
        <p>We look forward to welcoming you!</p>
      `,
      hilversumTemporaryText: (ctx) => `
        <p>On Friday, December 1st, we will be opening our newest restaurant in the charming center of Hilversum.</p>
        <p>We warmly welcome you to come and enjoy our steak and other delicious dishes here.</p>
        <p>You can already make a reservation (also for the holidays) by calling <strong>035-2002838</strong>.</p>
        <p>See you soon!</p>
      `,
      amsterdamFestivalHint: (ctx) => `
        <span class="text-bold">Accessibility Amsterdam – June 20-22.</span> <br />
        On June 21, Festival Op de Ring will take place due to 750 years of Amsterdam.
        This may affect the accessibility of our locations
        in Amsterdam on June 20, 21, and 22. For more information, visit
        <a href="https://opdering.amsterdam/bereikbaarheid" target="_blank" class="text-orange-8">opdering.amsterdam/bereikbaarheid</a>.
      `,
      sailAmsterdamMessage: 'Due to SAIL in Amsterdam, reservations are closed. Come visit us!',
      buttons: {
        proceed: 'Enter your details',
        goBqt: 'Group request (configurator)',
        goBqtAlt: 'Compose your arrangement here',
        reserve: 'Reserve now',
        callUs: (ctx) => `
          Call us: ${ctx.named('phone')}
        `
      }
    },
    results: {
      description: `Feel free to walk in without a reservation.<br>
        All Loetje Restaurants have a cozy bar
        where you can have a drink before you come to the table.`
    },
    reservation: {
      heading: 'Enter your details:',
      headingForAuthenticated: 'Your details:',
      headingForUpdate: 'Change your reservation:',
      undefinedLocation: 'Undefined location',
      dateNotAvailable: 'This date is not available',
      xmasLargeGroupMessage: `
        <p>For parties of 12 guests or more we offer special Christmas arrangements. We're happy to help you find the best fit.</p>
        <p>Send us a message on WhatsApp — we're happy to advise you on the possibilities.</p>
        <p>We look forward to welcoming you!</p>
      `,
      noAvailableTimes: (ctx) => `
        <strong>Unfortunately there is no availability online for the desired number of guests.
        Please contact us by phone, we will be happy to help you.
        <a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a> (from 9:00-21:00)</strong>
        <br><br>
        <strong>Have you made a request for a group larger than 14 guests? Please contact our team via the email you received with the offer. (<a href="mailto:events@rce.eu">events@rce.eu</a>)</strong>
      `,
      buttons: {
        proceed: 'Next step'
      }
    },
    checkInfo: {
      heading: 'Please check your details below',
      reservationInfo: (ctx) => `
        I will eat at
        <strong>${ctx.named('location')}</strong>
        <strong>${ctx.named('date')}</strong>
        at <strong>${ctx.named('time')}</strong>
        for <strong>${ctx.named('party_size')}</strong> people.
        <br><br>
        My name is ${ctx.named('first_name')} ${ctx.named('last_name')},
        email <strong>${ctx.named('email')}</strong>,
        phone number <strong>${ctx.named('phone_number')}</strong>
        ${ctx.named('child_seats')
    ? `<br><br>Number of highchairs (if needed): <strong>${ctx.named('child_seats')}</strong>`
    : ''}
        ${ctx.named('wheelchair_users') !== undefined && ctx.named('wheelchair_users') !== null
    ? `<br>Disabled guests in the party?: <strong>${ctx.named('wheelchair_users') ? 'YES' : 'NO'}</strong>`
    : ''}
      `,
      // wheelchair <strong>${ctx.named('wheelchair_users') ? 'YES' : 'NO'}</strong>,
      // high chair <strong>${ctx.named('child_seats') ? 'YES' : 'NO'}</strong>
      buttons: {
        approve: 'Next step',
        changeDetails: 'Change my details'
      }
    },
    codeInput: {
      heading: 'You are almost there, this is the last step.',
      info: (ctx) => {
        let wayToCommunicate = ctx.named('wayToCommunicate') || 'email',
          wayString = (wayToCommunicate === 'phone_number') ? 'SMS' : 'email'
        return `
          Your reservation is almost ready!<br>
          We have sent you an ${wayString} with a 6-digit code.<br>
          Enter this code below to confirm the reservation.
        `
      },
      infoForRetrieve: 'We have sent your 6-digit code to:',
      checkYourData: (ctx) => {
        let wayToCommunicate = ctx.named('wayToCommunicate') || 'email'
        return (wayToCommunicate === 'email')
          ? `
            Didn't receive an email?<br>
            Check your spam folder and check your email address:
          `
          : ''
      },
      buttons: {
        change: 'change',
        confirm: 'Confirm my reservation',
        resend: 'Resend Code'
      },
      successMessage: 'Code was sent successfully'
    },
    preProcess: {
      heading: 'Pay attention',
      info: (ctx) => `
        You have entered a different email address than you previously used with this phone number.
        <br><br>
        Do you want to use this new email address for this reservation?
        <br><br>
        Current: <span class="text-weight-medium">${ctx.named('oldEmail')}</span><br>
        New: <span class="text-weight-medium">${ctx.named('newEmail')}</span>
      `,
      buttons: {
        ok: 'Yes',
        no: 'No'
      }
    },
    yourCode: {
      heading: 'Confirm your reservation',
      info: `Nice that you want to eat at Loetje's! To confirm your reservation,
        we ask you to enter the verification code below on the website.`,
      yourCode: 'Your code',
      buttons: {
        confirm: 'Confirm your reservation'
      },
      hint: `Have you not made a reservation with Loetje?<br>
        Then you can ignore this email.`
    },
    reservationSuccess: {
      heading: 'Thank you for your reservation',
      info: `Nice of you to visit.<br>
        We are excited!`,
      reservationNumber: 'Your reservation number:',
      copySuccessMessage: 'Reservation number copied to clipboard',
      extraInfo: (ctx) => {
        return ctx.named('email')
          ? `
            A confirmation of this reservation
            has been sent to <span class="text-weight-medium">${ctx.named('email')}</span>
          `
          : ''
      },
      buttons: {
        goHome: 'Go to Loetje.nl'
      }
    },
    reservationFailed: {
      error409: 'Unfortunately this time is no longer available for booking',
      errorOneTimeDealCodeAlreadyUsed: 'An error occurred. This action link has already been used for a reservation',
      errorBadOneTimeDealCode: 'An error occurred. Please use the reservation link from your email to make a reservation',
      buttons: {
        chooseAnotherTime: 'Restart'
      }
    },
    reservations: {
      list: {
        heading: 'Your reservations',
        caption: 'Do you want to modify? Click on your reservation:',
        itemCaption: (ctx) => `
          ${ctx.named('date')},
          at ${ctx.named('time')}
        `,
        empty: 'There are no reservations',
        cancel: 'Cancel reservation',
        signout: 'Log out',
        edit: 'Edit',
        updateSuccessMessage: 'Your reservation has been successfully changed'
      },
      cancel: {
        confirmation: 'Are you sure to cancel this reservation?',
        // Unfortunately, it is no longer possible to cancel this reservation.
        cancellation_disabled: (ctx) => `
          Sorry, you can not cancel the reservation at this time. <br>
          Please contact the restaurant directly:
          <a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}" class="text-white text-bold text-underline">
          ${ctx.named('phone')}</a>
        `,
        buttons: {
          confirm: 'Yes, cancel my reservation',
          goHome: 'Go to Loetje.nl'
        }
      },
      cancelSuccess: {
        heading: 'Your reservation has been cancelled',
        info: (ctx) => `
          A confirmation of this cancellation has been sent to
          <span class="text-weight-medium">${ctx.named('email')}</span>

        `,
        buttons: {
          reservationsList: 'My reservations list',
          goHome: 'Go to Loetje.nl'
        }
      },
      retrieve: {
        // heading: 'Enter your reservation number to manage your reservation, or log in with email address:',
        heading: 'Enter your reservation number to manage your reservation, or log in with phone number:',
        issues: {
          invalidConfirmationNumber: 'Invalid confirmation number'
        },
        buttons: {
          confirm: ''
        }
      }
    },
    users: {
      update: {
        heading: 'Last step!',
        info: 'Enter your email address below to receive your reservation confirmation',
        buttons: {
          confirm: 'Yes, update my email'
        }
      },
      codeInput: {
        heading: 'Confirm your update',
        info: `We have sent you an SMS with a 6-digit code.<br>
          Enter this code below to confirm email updating.`,
        buttons: {
          confirm: 'Confirm',
          resend: 'Resend Code'
        }
      },
      updatingSuccess: {
        heading: 'Email was update successfully',
        info: `Nice of you to visit.<br> We are excited!`,
        extraInfo: (ctx) => {
          return ctx.named('email')
            ? `
              Your current email: ${ctx.named('email')}
            `
            : ''
        },
        buttons: {
          goHome: 'Go to Loetje.nl'
        }
      }
    }
  },
  locationSelector: {
    choosenLocation: 'Choosen location:',
    changeLocation: 'Change location',
    description: 'Please send your location details?',
    autoSelect: 'Yes (send location data automatically)',
    manualSelect: 'No (I will choose my location myself)',
    requestCoordinates: 'Select your location.'
  },
  groupSizePicker: {
    label: '{value} person | {value} persons'
  },
  restaurantInfoBlock: {
    address: 'Address',
    parking: 'Parking',
    experiences: 'Experiences',
    route: 'Route',
    openingHours: 'Opening hours',
    bages: {
      pets: 'Dogs on leash welcome',
      accessible: 'Disabled toilet available',
      terrace: 'Terrace&nbsp;<strong>not</strong>&nbsp;to be reserved'
    }
  },
  alternativesList: {
    heading: `Is your preferred time not available?<br>
      Check availability at other locations:`
  },
  restaurantsCard: {
    buttons: {
      changeLocation: 'Change location',
      moreInformation: 'More information'
    }
  },
  reservationInfoPanel: {
    addToCalendar: 'Add to calendar',
    route: 'Route',
    newReservation: 'New reservation'
  },
  timeSlotPicker: {
    sessionHeading: 'You want:',
    timeHeading: 'Choose your desired time:',
    timeHeadingForBigGroups: 'At the moment we like to receive groups at a few fixed times:',
    emptyList: 'Empty list',
    availableTimeslotText: 'Reserve now!',
    unavailableTimeslotText: 'Coming by?',
    unavailableTimeslotHint: (ctx) => {
      // const sid = ctx.named('sid') || 'default'
      // default text
      let text = `Join us without a reservation! <br />
        If a table is not immediately available,
        you can have a drink at the bar while we make sure you get to
        your table as soon as possible. Will we see you soon?`
      return text
    },
    unavailableTimeslotHint2: (ctx) => `Are you interested in the availability
      at one of our other Loetje locations?
      Below you can find the locations nearby or contact us,
      we are happy to check with you.
      (<a href="tel:${ctx.named('phone')}" target="${ctx.named('target') || '_self'}">${ctx.named('phone')}</a>)
      (from 11:00 to 20:00)
    `,

    unavailableTimeslotTextXmas: 'Fully booked!',
    unavailableTimeslotHintXmas: () => `
      <p>Unfortunately, the restaurant is fully booked at this time. Please check our availability at other times or select one of our other locations.</p>
      <p>Prefer to get in touch? No problem. We're happy to help you find the best options.</p>
    `,

    unavailableTimeslotTextPromo: 'Fully booked!',
    unavailableTimeslotHintPromo: () => `
      <p>Unfortunately, the restaurant is fully booked at this time. Please check our availability at other times or select one of our other locations.</p>
      <p>Prefer to get in touch? No problem. We're happy to help you find the best options.</p>
    `,

    tableDurationNote: (ctx) => `Your table is reserved until ${ctx.named('endTime')} at the latest.`,

    terraceProposition: `<strong>Terrace</strong><br>
      <span class="text-italic">We keep our terros completely free for walk-ins, so feel free to come and pick a spot.</span>`
  },
  timeSlotInput: {
    time: 'Time'
  },
  sessionsList: {
    breakfast: 'Morning',
    lunch: 'Afternoon',
    dinner: 'Evening',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening'
  }
}
